export const SET_CURRENT_ROUTE = 'SET_CURRENT_ROUTE';